"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSeriesFieldDictionariesImpl = void 0;
const inversify_1 = require("inversify");
const field_dictionaries_1 = require("../../../../field-dictionaries");
let TimeSeriesFieldDictionariesImpl = class TimeSeriesFieldDictionariesImpl {
    constructor(session) {
        this.session = session;
        this.openPromise = null;
        this.dictionariesStream = (0, field_dictionaries_1.Definition)().getStream(session);
    }
    getStream() {
        return this.dictionariesStream;
    }
    async open() {
        if (this.openPromise === null) {
            this.openPromise = this.dictionariesStream.open();
        }
        await this.openPromise;
    }
};
exports.TimeSeriesFieldDictionariesImpl = TimeSeriesFieldDictionariesImpl;
exports.TimeSeriesFieldDictionariesImpl = TimeSeriesFieldDictionariesImpl = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)('TimeSeriesSession'))
], TimeSeriesFieldDictionariesImpl);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZS1zZXJpZXMtZmllbGQtZGljdGlvbmFyaWVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbnRlbnQvaGlzdG9yaWNhbC1wcmljaW5nL3RpbWUtc2VyaWVzL3NlcnZpY2VzL3RpbWUtc2VyaWVzLWZpZWxkLWRpY3Rpb25hcmllcy90aW1lLXNlcmllcy1maWVsZC1kaWN0aW9uYXJpZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEseUNBQStDO0FBRS9DLHVFQUE0RDtBQUdyRCxJQUFNLCtCQUErQixHQUFyQyxNQUFNLCtCQUErQjtJQUl4QyxZQUF5QyxPQUF5QjtRQUFoQixZQUFPLEdBQVAsT0FBTyxDQUFTO1FBRjFELGdCQUFXLEdBQXlELElBQUksQ0FBQztRQUc3RSxJQUFJLENBQUMsa0JBQWtCLEdBQUcsSUFBQSwrQkFBVSxHQUFFLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQzlELENBQUM7SUFFRCxTQUFTO1FBQ0wsT0FBTyxJQUFJLENBQUMsa0JBQWtCLENBQUM7SUFDbkMsQ0FBQztJQUNELEtBQUssQ0FBQyxJQUFJO1FBQ04sSUFBSSxJQUFJLENBQUMsV0FBVyxLQUFLLElBQUksRUFBRSxDQUFDO1lBQzVCLElBQUksQ0FBQyxXQUFXLEdBQUcsSUFBSSxDQUFDLGtCQUFrQixDQUFDLElBQUksRUFBRSxDQUFDO1FBQ3RELENBQUM7UUFDRCxNQUFNLElBQUksQ0FBQyxXQUFXLENBQUM7SUFDM0IsQ0FBQztDQUNKLENBQUE7QUFqQlksMEVBQStCOzBDQUEvQiwrQkFBK0I7SUFEM0MsSUFBQSxzQkFBVSxHQUFFO0lBS0ksV0FBQSxJQUFBLGtCQUFNLEVBQUMsbUJBQW1CLENBQUMsQ0FBQTtHQUovQiwrQkFBK0IsQ0FpQjNDIn0=